import { render, staticRenderFns } from "./Flexercise.vue?vue&type=template&id=4c28a323&scoped=true&"
import script from "./Flexercise.vue?vue&type=script&lang=js&"
export * from "./Flexercise.vue?vue&type=script&lang=js&"
import style0 from "./Flexercise.vue?vue&type=style&index=0&id=4c28a323&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c28a323",
  null
  
)

export default component.exports